import React, {Component} from 'react';

import UserContextMenu from '../UserContextMenu/index';
import UserContextMenuItem from '../UserContextMenuItem/index';
import Popup from '../Popup/index';

import Registry from '../../../registry/index';

import './styles.scss';

class UserListItemContextMenu extends UserContextMenu  {
    constructor(props) {
        super(props);

        this.action = this.action.bind(this);
        this.state = {
            position: '',
            no_arrow: false
        };
    }

    position() {
        if (!this.$anchor || this.$anchor.length === 0) return;

        let {chatLog} = this.props;

        let offset = this.$anchor.offset(),
            popupWidth = this.$popup.width(),
            popupHeight = this.$popup.height(),
            anchorWidth = this.$anchor.width(),
            anchorHeight = this.$anchor.height(),
            windowHeight = window.innerHeight,
            windowWidth = window.innerWidth;

        let top, left;

        let newState = {
            position : '',
            no_arrow : false
        };

        if (offset.top + anchorHeight + popupHeight < windowHeight) {
            top = offset.top + anchorHeight + (chatLog ? 8 : 0);
            left = offset.left + anchorWidth / 2 - popupWidth / 2;
        } else if (offset.top - popupHeight > 0) {
            newState.position = "top";
            top = offset.top - popupHeight - 8 + (chatLog ? -4 : 0);
            left = offset.left + anchorWidth / 2 - popupWidth / 2;
        } else {
            newState.position = "left";
            top = offset.top - popupHeight / 2 + 2;
            left = offset.left - popupWidth;
        }

        if(left < 0) {
            left = 0;
            newState.no_arrow = true;
        }

        this.setState(newState);

        //console.log("top:" + top + "; left:" + left);

        this.$popup.css({
            top: top + "px",
            left: left + "px"
        });
    }

    render() {
        let lang = Registry.get('locale');

        let {currentUser, currentRoom, user} = this.props;

        let allItems = super.getAllItems(lang, user, currentRoom);

        let availableItems = [];

        for (let action in allItems) {
            let item = allItems[action];
            let disabled = !super.itemEnabled(action, user, currentUser);

            if (super.itemVisible(action, user, currentUser)) {
                availableItems.push(<UserContextMenuItem key={action} {...item} disabled={disabled}/>);
            }
        }

        let className = 'popup block-menu-rightclick ' + ' ' + this.state.position + ' ' + (this.state.no_arrow ? "no-arrow" : '') + ' ' + this.state.visibility;

        return (
            <div className={className} ref={(self) => {this._ref = self}}>
                <ul>{availableItems}</ul>
            </div>
        )
    }
}

UserListItemContextMenu.generateKey = function(props) { return 'user-list-item-context-menu' };
UserListItemContextMenu.mount = function(props) { return Popup.mount(UserListItemContextMenu, props) };

export default UserListItemContextMenu;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UserListItemContextMenu/index.js